<template>
    <vx-input v-bind="attrs" v-on="listeners" v-mask="appliedMask" v-model="phoneNumber" />
</template>

<script>
export default {
    name: 'vx-phone-input',
    props: {
        value: {
            type: String
        },
        mobile: {
            type: Boolean,
            default: false
        },
        rules: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            phoneNumberX: null,
            appliedMask: '',
            backupValue: -1
        }
    },
    watch: {
        value: {
            handler: function (newv, oldv) {
                // HACK: Must set the mask before the value, other v-mask forces the
                // old value to confirm to the new mask and erases it
                // NOTE: the input cannot be set to clearable, it causes bugs (not sure why, spent too long searching)
                if (this.backupValue != -1) {
                    if (this.backupValue == null || !newv) {
                        this.phoneNumber = this.backupValue
                    } else {
                        this.phoneNumber = newv
                    }
                    this.backupValue = -1
                } else {
                    var newMask = this.getMask(newv)

                    if (this.appliedMask !== newMask) {
                        if (newv || oldv) {
                            this.backupValue = newv
                        }
                        this.appliedMask = newMask
                    }
                }
            },
            immediate: true
        }
    },
    computed: {
        phoneNumber: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        listeners() {
            delete this.$listeners.input
            return this.$listeners
        },
        attrs() {
            return {
                name: this.mobile ? 'mobile' : 'phone',
                icon: this.mobile ? 'icon-smartphone' : 'icon-phone',
                placeholder: this.mobile ? '#### ### ###' : '(##) #### ####',
                ...this.$attrs,
                rules: [...this.rules, 'phone'],
                clearable: false
            }
        }
    },
    methods: {
        getMask(value) {
            // No number set, use defaults
            if (!value) {
                if (this.mobile) {
                    return '#### ### ###'
                } else {
                    return '(##) #### ####'
                }
            }

            var trimmed = value.replace(/[^\d+()]/g, '')
            if (trimmed.length >= 3) {
                // Australian mobile number
                if (trimmed.startsWith('04')) {
                    return '#### ### ###'
                }

                // International code is set
                if (trimmed.startsWith('+')) {
                    if (trimmed.startsWith('+61')) {
                        if (this.mobile) {
                            return '+## ### ### ###'
                        }
                        return '+### #### ####'
                    } else if (trimmed.startsWith('+1')) {
                        return '+#-###-###-####'
                    } else if (trimmed.startsWith('+7')) {
                        return '+#-###-###-##-##'
                    } else if (trimmed.startsWith('+44')) {
                        return '+## #### ######'
                    } else if (trimmed.startsWith('+63')) {
                        return '+## (###) ### ####'
                    }
                    return '+XXXXXXXXXXXXXX'
                }

                if (trimmed.startsWith('0') || trimmed.startsWith('(')) {
                    return '(##) #### ####'
                } else if (trimmed.length < 9) {
                    return '#### ####'
                }
            }
            return 'XXXXXXXXXXXXXXX'
        }
    }
}
</script>

<style></style>
